/* eslint-disable @typescript-eslint/naming-convention */
import { Inject, Injectable } from '@angular/core';
import { JsonApiResponse } from '@boxx/core/lib/contracts/IHttpBasicResponse';
import { IBrandigApiProps } from '@boxx/dynamic-branding/lib/services/dynamic-branding-service';
import { EcwidModel } from '@boxx/store-core/lib/models/Ecwid.model';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { LocalStorageNativeService } from 'src/services/NativeLocalStorage.service';
import { BusinessModel, ConfigNotificationsDataProps } from '../models/BusinessConfig.model';
import { OnboardingRegistrationGmbDataProps } from '../models/Registration.model';
import {
  BusinessSiteFields,
  BusinessUpdateApiRespProps,
  BusinessUpdatePayloadProps,
  IDeleteImageFormProps,
  IDeleteImageResponse,
  IGetBusinessImagesApiRespoProps,
  IGetSiteImagesProps,
  ISearchClientResponse,
  IWizardCreateUserPayloadProps,
  IWizardUserBusinessAdditionalInfoResponse,
  IWizardUserBusinessInfoResponse,
  IWizardUserPersonalInfoResponse,
} from '../repositories/IOnboarding.api';
import {
  IBusinessUpdateInfoPayload,
  IImageFormProps,
  IOnboardingRepository,
  IRatingAppProps,
  ITokenEcwid,
  ONBOARDING_REPOSITORY,
  UpdateMetaPayloadProps,
} from '../repositories/IOnboarding.repository';
import { IOnboardingService } from './IOnboarding.service';
import { SELECTED_LANGUAGE_LS_KEY } from 'src/services/translate/languagesData';

@Injectable()
export class OnboardingService implements IOnboardingService {
  constructor(
    @Inject(ONBOARDING_REPOSITORY) private repository: IOnboardingRepository,
    public storageService: LocalStorageNativeService,
  ) {}

  getBusinessData() {
    return this.repository
      .getBusinessData()
      .pipe(
        map((response) => {
          let ecwic_sync = false;
          let ventasclickpay_sync = false;
          let score = false;
          let stars = 0;
          let review = '';
          let suscriptionClient = '';

          if (typeof response.data.meta.ecwid_sync !== 'undefined') {
            ecwic_sync = (response.data.meta.ecwid_sync) ? true : false;
          }

          if (typeof response.data.meta.ventasclickpay_sync !== 'undefined') {
            ventasclickpay_sync = (response.data.meta.ventasclickpay_sync) ? true : false;
          }

          if (response.data.meta.calificacion && response.data.meta.calificacion !== null && typeof response.data.meta.calificacion !== 'undefined') {
            score = (response.data.meta.calificacion) ? true : false;
            stars = (response.data.meta.calificacion.calificacion !== 'undefined') ? response.data.meta.calificacion.calificacion : 0;
            review = (response.data.meta.calificacion.descripcion !== 'undefined') ? response.data.meta.calificacion.descripcion : '';
          }

          if (response.data.attributes.external_subscription_id && response.data.attributes.external_subscription_id !== null && typeof response.data.attributes.external_subscription_id !== 'undefined') {
            suscriptionClient = (response.data.attributes.external_subscription_id) ? response.data.attributes.external_subscription_id : '';
          }

          response.data.attributes.score = score;
          response.data.attributes.stars = stars;
          response.data.attributes.review = review;
          
          response.data.attributes.ecwic_sync = ecwic_sync; 
          response.data.attributes.ventasclickpay_sync = ventasclickpay_sync;           
          response.data.attributes.brand = response.data.meta.brand.name ? response.data.meta.brand.name : 'Box';

          response.data.attributes.BUSINESS_CONFIG_GMB_STATUS = response.data.meta.BUSINESS_CONFIG_GMB_STATUS ? response.data.meta.BUSINESS_CONFIG_GMB_STATUS : false;
          response.data.attributes.BUSINESS_CONFIG_NOTIFICATIONS = response.data.meta.BUSINESS_CONFIG_NOTIFICATIONS ? response.data.meta.BUSINESS_CONFIG_NOTIFICATIONS : false;
          response.data.attributes.BUSINESS_CONFIG_PAYMENTS = response.data.meta.BUSINESS_CONFIG_PAYMENTS ? response.data.meta.BUSINESS_CONFIG_PAYMENTS : false;
          response.data.attributes.BUSINESS_CONFIG_SCHEDULE = response.data.meta.BUSINESS_CONFIG_SCHEDULE ? response.data.meta.BUSINESS_CONFIG_SCHEDULE : false;
          response.data.attributes.BUSINESS_CONFIG_SERVICES = response.data.meta.BUSINESS_CONFIG_SERVICES ? response.data.meta.BUSINESS_CONFIG_SERVICES : false;
          response.data.attributes.BUSINESS_CONFIG_SOCIAL = response.data.meta.BUSINESS_CONFIG_SOCIAL ? response.data.meta.BUSINESS_CONFIG_SOCIAL : false;
          response.data.attributes.BUSINESS_CONFIG_WEBSITE = response.data.meta.BUSINESS_CONFIG_WEBSITE ? response.data.meta.BUSINESS_CONFIG_WEBSITE : false;

          response.data.attributes.BUSINESS_REGISTRATION = response.data.meta.BUSINESS_REGISTRATION ? response.data.meta.BUSINESS_REGISTRATION : false;
          response.data.attributes.USER_HAS_GMB_ACCOUNT = response.data.meta.USER_HAS_GMB_ACCOUNT ? response.data.meta.USER_HAS_GMB_ACCOUNT : false;
          response.data.attributes.GMB_CREATE_OR_SYNC = response.data.meta.GMB_CREATE_OR_SYNC ? response.data.meta.GMB_CREATE_OR_SYNC : false;

          response.data.attributes.email_user = response.data.meta.user.email ? response.data.meta.user.email : '';
          response.data.attributes.phone = response.data.meta.user.phone ? response.data.meta.user.phone : '';
          response.data.attributes.ALLOW_FOOD_MENU = (response.data.meta.GBP_HAS_FOOD_MENU !== undefined) ? response.data.meta.GBP_HAS_FOOD_MENU : false;
        
        let allowStore = false;
        let allowSite = false;
        let allowCRM = false;
        let allowFacebook = false;
        let allowBooking = false;
        let allowGMB = false;
        let allowVentasclickpay = false;
        let allowDirectory = false;
        let bookingSync = false;

        let third_id = null;

        if (typeof response.data.meta.booking_sync !== 'undefined') {
          bookingSync = (response.data.meta.booking_sync) ? response.data.meta.booking_sync : false;
        }

        if (typeof response.data.attributes.third_id !== undefined) {
          third_id = (response.data.attributes.third_id) ? response.data.attributes.third_id : null;
        }

        if(response.data.meta.permissions){
          if(response.data.meta.permissions !== undefined){    
            response.data.meta.permissions.forEach( function(permission, index) {
              if(permission === 'agency_website'){
                allowSite = true;
              }
              if(permission === 'crm'){
                allowCRM = true;
              }
              if(permission === 'facebook'){
                allowFacebook = true;
              }
              if(permission === 'gmb'){
                allowGMB = true;
              }
              if(permission === 'ventasclickpay'){
                allowVentasclickpay = true;
              }
              if(permission === 'shop'){
                  allowStore = true;
              }
              if(permission === 'directory'){
                allowDirectory = true;
              }
              if(permission === 'booking'){
                allowBooking = true;
              }
            });
          }
        }

        this.storageService.getItem(SELECTED_LANGUAGE_LS_KEY).then(
          (currentLng)=>{
            if(currentLng === undefined || currentLng === null){
              console.log('asignar: ', currentLng);
              this.storageService.setItem(SELECTED_LANGUAGE_LS_KEY, response.data.attributes.language_code);
            }
          }
        );

        response.data.attributes.suscriptionClient = suscriptionClient;
        response.data.attributes.BOOKING_SYNC = bookingSync;
          response.data.attributes.ALLOW_STORE = allowStore;
          response.data.attributes.ALLOW_SITE = allowSite;
          response.data.attributes.ALLOW_CRM = allowCRM;
          response.data.attributes.ALLOW_FACEBOOK = allowFacebook;
          response.data.attributes.ALLOW_BOOKING = allowBooking;
          response.data.attributes.ALLOW_GMB = allowGMB;
          response.data.attributes.ALLOW_VENTASCLICKPAY = allowVentasclickpay;
          response.data.attributes.ALLOW_DIRECTORY = allowDirectory;
          
          response.data.attributes.third_id = third_id;
          response.data.attributes.brand_id = response.data.attributes.brand_id;
          return BusinessModel.fromApiResponse(response.data.attributes as any); 
          
        })
      );
  }

  getTemplates(payload: string): Observable<any> {
    return this.repository
      .getTemplates(payload)
      .pipe(map((response) => response.data.attributes));
  }

  getColorThemes(): Observable<any> {
    return this.repository
      .getColorThemes()
      .pipe(map((response) => response.data.attributes));
  }

  verifySubscriptionStatus(brand_id: any, subscription_id: any): Observable<any> {
    return this.repository
      .verifySubscriptionStatus(brand_id, subscription_id)
      .pipe(map((response) => response.data.attributes));
  }
  
  getPanelLink(): Observable<any> {
    return this.repository
      .getPanelLink()
      .pipe(map((response) => response.data));
  }
  
  getImagesData(): Observable<IGetBusinessImagesApiRespoProps> {
    throw new Error('Method not implemented.');
  }

  deleteBusinessImage(
    payload: IDeleteImageFormProps
  ): Observable<IDeleteImageResponse> {
    return this.repository
      .deleteBusinesImage(payload)
      .pipe(map((response) => response.data.attributes));
  }

  deleteBusinessImagePromise(payload: IDeleteImageFormProps): Promise<any> {
    return this.repository
      .deleteBusinesImage(payload)
      .pipe(map((response) => response.data.attributes))
      .toPromise();
  }

  uploadImageData(payload: IImageFormProps): Promise<any> {
    return this.repository
      .uploadImageData(payload)
      .pipe(map((response) => response.data.attributes))
      .toPromise();
  }

  createDirectory(): Observable<any> {
    return this.repository
      .createDirectory()
      .pipe(map((response) => response.data.attributes));
  }

  getSiteFields(): Observable<BusinessSiteFields> {
    return this.repository
      .getSiteFields()
      .pipe(map((response) => response.data.attributes));
  }

  getSiteFieldsByLanguage(lng: string): Observable<BusinessSiteFields> {
    return this.repository
      .getSiteFieldsByLanguage(lng)
      .pipe(map((response) => response.data.attributes));
  }

  updateSiteFieldsEnglish(payload: any): Promise<any> {
    return this.repository
      .updateSiteFieldsEnglish(payload)
      .pipe(map((response) => response))
      .toPromise();
  }

  
  getSiteImages(): Observable<IGetSiteImagesProps> {
    return this.repository
      .getSiteImages()
      .pipe(map((response) => response.data.attributes));
  }

  updateSiteFields(payload: BusinessSiteFields): Promise<any> {
    return this.repository
      .updateSiteFields(payload)
      .pipe(map((response) => response.data.attributes))
      .toPromise();
  }

  getUploadImagesUrl() {
    return this.repository.getUploadImagesUrl();
  }

  // ------------- REGISTRATION -------------
  saveUserData(
    payload: IWizardCreateUserPayloadProps
  ): Observable<{ token: string; brand: any }> {
    const dataUser: IWizardCreateUserPayloadProps = {
      name: payload.name,
      last_name: payload.last_name,
      language: payload.language,
      country_code: payload.country_code,
      email: payload.email,
      phone: (payload.phone || '').replace(/[()-]/g, ''),
      password: payload.password,
      confirm_password: payload.password,
      brand_id: (payload.brand_id !== undefined) ? payload.brand_id : 1,
      partner_id: null,
      platform_login: (payload.platform_login) ? payload.platform_login : 'default',
      third_id: payload.third_id ? payload.third_id : ''
    };

    return this.repository.saveUserData(dataUser).pipe(
      map((response) => ({
        token: response.data.attributes.token,
        brand: response.data.meta?.brand,
      }))
    );
  }

  saveUserFormDataMeed(
    payload: FormData
  ): Observable<{ token: string; brand: any }> {
    return this.repository.saveUserFormDataMeed(payload).pipe(
      map((response) => ({
        token: response.data.attributes.token,
        brand: response.data.meta?.brand,
      }))
    );
  }

  getConfigNotifications() {
    return this.repository.getConfigNotifications()
    .pipe(map((response) => response.data.attributes));
  }
  
  updateConfigNotifications(
    payload: FormData
  ): Observable<{ token: string; brand: any }> {
    return this.repository.updateConfigNotifications(payload)
    .pipe(map((response) => response.data.attributes));
  }

  validaZipcode(zipcode: number): Observable<any> {
    return this.repository
      .validaZipcode(zipcode)
      .pipe(map((response) => response.data.attributes));
  }

  saveGmbData(
    payload: OnboardingRegistrationGmbDataProps
  ): Observable<BusinessUpdateApiRespProps> {
    const dataBusiness: BusinessUpdatePayloadProps = {
      business_name: payload.businessName,
      email_user: payload.email,

      phone: payload.phone.replace(/\D/g, ''),

      street_address:
        payload.streetAddress !== null ? payload.streetAddress : '',
      address_ext_number: payload.addressExtNumber,
      latitude: payload.latitude !== null ? payload.latitude : 0,
      longitude: payload.longitude !== null ? payload.longitude : 0,
      template_id: payload.templateId,
      template_description: payload.templateDescription,

      full_address: payload.fullAddress !== null ? payload.fullAddress : '',
      settlement: payload.settlement !== null ? payload.settlement : '',
      locality: payload.locality !== null ? payload.locality : '',
      state: payload.state !== null ? payload.state : '',
      country: payload.country !== null ? payload.country : '',
    };

    return this.repository
      .updateBusinessData(dataBusiness)
      .pipe(map((response) => response.data.attributes));
  }

  // ------------- BUSINESS CONFIG -------------

  /**
   * Este se usará para guardar toda la data del negocio EXCEPTO:
   * Products (or Services)
   * Schedule (and schedule notes)
   * Payment methods
   *
   * @see IBusinessUpdatePayloadProps
   * */
  updateBusinessData(
    businessInfo: OnboardingRegistrationGmbDataProps
  ): Observable<BusinessModel> {
    let businessInfo2 = businessInfo;

    if (businessInfo.phone) {
      businessInfo2 = {
        ...businessInfo,
        phone: businessInfo.phone
          ? (businessInfo.phone || '').replace(/[()-]/g, '')
          : '',
      };
    }
    if (businessInfo.mobile_phone) {
      businessInfo2 = {
        ...businessInfo,
        mobile_phone: businessInfo.mobile_phone
          ? (businessInfo.mobile_phone || '').replace(/[()-]/g, '')
          : '',
      };
    }

    return this.repository
      .updateBusinessData(businessInfo2)
      .pipe(
        map((response) => {
          let ecwic_sync = false;
          let ventasclickpay_sync = false;
          let score = false;
          let stars = 0;
          let review = '';
          let suscriptionClient = '';
          
          if (typeof response.data.meta.ecwid_sync !== 'undefined') {
            ecwic_sync = (response.data.meta.ecwid_sync) ? true : false;
          }

          if (typeof response.data.meta.ventasclickpay_sync !== 'undefined') {
            ventasclickpay_sync = (response.data.meta.ventasclickpay_sync) ? true : false;
          }

          if (response.data.meta.calificacion && response.data.meta.calificacion !== null && typeof response.data.meta.calificacion !== 'undefined') {
            score = (response.data.meta.calificacion) ? true : false;
            stars = (response.data.meta.calificacion.calificacion !== 'undefined') ? response.data.meta.calificacion.calificacion : 0;
            review = (response.data.meta.calificacion.descripcion !== 'undefined') ? response.data.meta.calificacion.descripcion : '';
          }

          if (response.data.attributes.external_subscription_id && response.data.attributes.external_subscription_id !== null && typeof response.data.attributes.external_subscription_id !== 'undefined') {
            suscriptionClient = (response.data.attributes.external_subscription_id) ? response.data.attributes.external_subscription_id : '';
          }

          response.data.attributes.score = score;
          response.data.attributes.stars = stars;
          response.data.attributes.review = review;
          
          response.data.attributes.ecwic_sync = ecwic_sync; 
          response.data.attributes.ventasclickpay_sync = ventasclickpay_sync;             
          response.data.attributes.brand = response.data.meta.brand.name ? response.data.meta.brand.name : 'Box';

          response.data.attributes.BUSINESS_CONFIG_GMB_STATUS = response.data.meta.BUSINESS_CONFIG_GMB_STATUS ? response.data.meta.BUSINESS_CONFIG_GMB_STATUS : false;
          response.data.attributes.BUSINESS_CONFIG_NOTIFICATIONS = response.data.meta.BUSINESS_CONFIG_NOTIFICATIONS ? response.data.meta.BUSINESS_CONFIG_NOTIFICATIONS : false;
          response.data.attributes.BUSINESS_CONFIG_PAYMENTS = response.data.meta.BUSINESS_CONFIG_PAYMENTS ? response.data.meta.BUSINESS_CONFIG_PAYMENTS : false;
          response.data.attributes.BUSINESS_CONFIG_SCHEDULE = response.data.meta.BUSINESS_CONFIG_SCHEDULE ? response.data.meta.BUSINESS_CONFIG_SCHEDULE : false;
          response.data.attributes.BUSINESS_CONFIG_SERVICES = response.data.meta.BUSINESS_CONFIG_SERVICES ? response.data.meta.BUSINESS_CONFIG_SERVICES : false;
          response.data.attributes.BUSINESS_CONFIG_SOCIAL = response.data.meta.BUSINESS_CONFIG_SOCIAL ? response.data.meta.BUSINESS_CONFIG_SOCIAL : false;
          response.data.attributes.BUSINESS_CONFIG_WEBSITE = response.data.meta.BUSINESS_CONFIG_WEBSITE ? response.data.meta.BUSINESS_CONFIG_WEBSITE : false;

          response.data.attributes.BUSINESS_REGISTRATION = response.data.meta.BUSINESS_REGISTRATION ? response.data.meta.BUSINESS_REGISTRATION : false;
          response.data.attributes.USER_HAS_GMB_ACCOUNT = response.data.meta.USER_HAS_GMB_ACCOUNT ? response.data.meta.USER_HAS_GMB_ACCOUNT : false;
          response.data.attributes.GMB_CREATE_OR_SYNC = response.data.meta.GMB_CREATE_OR_SYNC ? response.data.meta.GMB_CREATE_OR_SYNC : false;

          response.data.attributes.email_user = response.data.meta.user.email ? response.data.meta.user.email : '';
          response.data.attributes.phone = response.data.meta.user.phone ? response.data.meta.user.phone : '';
          response.data.attributes.ALLOW_FOOD_MENU = (response.data.meta.GBP_HAS_FOOD_MENU !== undefined) ? response.data.meta.GBP_HAS_FOOD_MENU : false;
        

          let allowStore = false;
          let allowSite = false;
          let allowCRM = false;
          let allowFacebook = false;
          let allowBooking = false;
          let allowGMB = false;
          let allowVentasclickpay = false;
          let allowDirectory = false;
          let bookingSync = false;

          let third_id = null;

          if (typeof response.data.meta.booking_sync !== 'undefined') {
            bookingSync = (response.data.meta.booking_sync) ? response.data.meta.booking_sync : false;
          }

          if (typeof response.data.attributes.third_id !== undefined) {
            third_id = (response.data.attributes.third_id) ? response.data.attributes.third_id : null;
          }

          if(response.data.meta.permissions){
            if(response.data.meta.permissions !== undefined){    
              response.data.meta.permissions.forEach( function(permission, index) {
                if(permission === 'agency_website'){
                  allowSite = true;
                }
                if(permission === 'crm'){
                  allowCRM = true;
                }
                if(permission === 'facebook'){
                  allowFacebook = true;
                }
                if(permission === 'gmb'){
                  allowGMB = true;
                }
                if(permission === 'ventasclickpay'){
                  allowVentasclickpay = true;
                }
                if(permission === 'shop'){
                    allowStore = true;
                }
                if(permission === 'directory'){
                  allowDirectory = true;
                }
                if(permission === 'booking'){
                  allowBooking = true;
                }
              });
            }
          }

          response.data.attributes.suscriptionClient = suscriptionClient;
          response.data.attributes.BOOKING_SYNC = bookingSync;
            response.data.attributes.ALLOW_STORE = allowStore;
            response.data.attributes.ALLOW_SITE = allowSite;
            response.data.attributes.ALLOW_CRM = allowCRM;
            response.data.attributes.ALLOW_FACEBOOK = allowFacebook;
            response.data.attributes.ALLOW_BOOKING = allowBooking;
            response.data.attributes.ALLOW_GMB = allowGMB;
            response.data.attributes.ALLOW_VENTASCLICKPAY = allowVentasclickpay;
            response.data.attributes.ALLOW_DIRECTORY = allowDirectory;
            
            response.data.attributes.third_id = third_id;
            response.data.attributes.brand_id = response.data.attributes.brand_id;
          return BusinessModel.fromApiResponse(response.data.attributes);
        })
      );
  }

  /**
   * Este se usará para guardar la data (toda o por partes) SOLO de:
   * Products (or Services)
   * Schedule (and schedule notes)
   * Payment methods
   *
   * @see IBusinessUpdateInfoPayload
   * */
  updateBusinessInfoData(
    businessInfoData: IBusinessUpdateInfoPayload
  ): Observable<BusinessModel> {
    return this.repository
      .updateBusinessInfoData(businessInfoData)
      .pipe(
        map((response) => {
          let ecwic_sync = false;
          let ventasclickpay_sync = false;
          let score = false;
          let stars = 0;
          let review = '';
          let suscriptionClient = '';
         
          if (typeof response.data.meta.ecwid_sync !== 'undefined') {
            ecwic_sync = (response.data.meta.ecwid_sync) ? true : false;
          }

          if (typeof response.data.meta.ventasclickpay_sync !== 'undefined') {
            ventasclickpay_sync = (response.data.meta.ventasclickpay_sync) ? true : false;
          }

          if (response.data.meta.calificacion && response.data.meta.calificacion !== null && typeof response.data.meta.calificacion !== 'undefined') {
            score = (response.data.meta.calificacion) ? true : false;
            stars = (response.data.meta.calificacion.calificacion !== 'undefined') ? response.data.meta.calificacion.calificacion : 0;
            review = (response.data.meta.calificacion.descripcion !== 'undefined') ? response.data.meta.calificacion.descripcion : '';
          }

          if (response.data.attributes.external_subscription_id && response.data.attributes.external_subscription_id !== null && typeof response.data.attributes.external_subscription_id !== 'undefined') {
            suscriptionClient = (response.data.attributes.external_subscription_id) ? response.data.attributes.external_subscription_id : '';
          }

          response.data.attributes.score = score;
          response.data.attributes.stars = stars;
          response.data.attributes.review = review;
          
          response.data.attributes.ecwic_sync = ecwic_sync;  
          response.data.attributes.ventasclickpay_sync = ventasclickpay_sync;            
          response.data.attributes.brand = response.data.meta.brand.name ? response.data.meta.brand.name : 'Box';

          response.data.attributes.BUSINESS_CONFIG_GMB_STATUS = response.data.meta.BUSINESS_CONFIG_GMB_STATUS ? response.data.meta.BUSINESS_CONFIG_GMB_STATUS : false;
          response.data.attributes.BUSINESS_CONFIG_NOTIFICATIONS = response.data.meta.BUSINESS_CONFIG_NOTIFICATIONS ? response.data.meta.BUSINESS_CONFIG_NOTIFICATIONS : false;
          response.data.attributes.BUSINESS_CONFIG_PAYMENTS = response.data.meta.BUSINESS_CONFIG_PAYMENTS ? response.data.meta.BUSINESS_CONFIG_PAYMENTS : false;
          response.data.attributes.BUSINESS_CONFIG_SCHEDULE = response.data.meta.BUSINESS_CONFIG_SCHEDULE ? response.data.meta.BUSINESS_CONFIG_SCHEDULE : false;
          response.data.attributes.BUSINESS_CONFIG_SERVICES = response.data.meta.BUSINESS_CONFIG_SERVICES ? response.data.meta.BUSINESS_CONFIG_SERVICES : false;
          response.data.attributes.BUSINESS_CONFIG_SOCIAL = response.data.meta.BUSINESS_CONFIG_SOCIAL ? response.data.meta.BUSINESS_CONFIG_SOCIAL : false;
          response.data.attributes.BUSINESS_CONFIG_WEBSITE = response.data.meta.BUSINESS_CONFIG_WEBSITE ? response.data.meta.BUSINESS_CONFIG_WEBSITE : false;

          response.data.attributes.BUSINESS_REGISTRATION = response.data.meta.BUSINESS_REGISTRATION ? response.data.meta.BUSINESS_REGISTRATION : false;
          response.data.attributes.USER_HAS_GMB_ACCOUNT = response.data.meta.USER_HAS_GMB_ACCOUNT ? response.data.meta.USER_HAS_GMB_ACCOUNT : false;
          response.data.attributes.GMB_CREATE_OR_SYNC = response.data.meta.GMB_CREATE_OR_SYNC ? response.data.meta.GMB_CREATE_OR_SYNC : false;

          response.data.attributes.email_user = response.data.meta.user.email ? response.data.meta.user.email : '';
          response.data.attributes.phone = response.data.meta.user.phone ? response.data.meta.user.phone : '';
          response.data.attributes.ALLOW_FOOD_MENU = (response.data.meta.GBP_HAS_FOOD_MENU !== undefined) ? response.data.meta.GBP_HAS_FOOD_MENU : false;
        

          let allowStore = false;
          let allowSite = false;
          let allowCRM = false;
          let allowFacebook = false;
          let allowBooking = false;
          let allowGMB = false;
          let allowVentasclickpay = false;
          let allowDirectory = false;
          let bookingSync = false;

          let third_id = null;

          if (typeof response.data.meta.booking_sync !== 'undefined') {
            bookingSync = (response.data.meta.booking_sync) ? response.data.meta.booking_sync : false;
          }

          if (typeof response.data.attributes.third_id !== undefined) {
            third_id = (response.data.attributes.third_id) ? response.data.attributes.third_id : null;
          }

          if(response.data.meta.permissions){
            if(response.data.meta.permissions !== undefined){    
              response.data.meta.permissions.forEach( function(permission, index) {
                if(permission === 'agency_website'){
                  allowSite = true;
                }
                if(permission === 'crm'){
                  allowCRM = true;
                }
                if(permission === 'facebook'){
                  allowFacebook = true;
                }
                if(permission === 'gmb'){
                  allowGMB = true;
                }
                if(permission === 'ventasclickpay'){
                  allowVentasclickpay = true;
                }
                if(permission === 'shop'){
                    allowStore = true;
                }
                if(permission === 'directory'){
                  allowDirectory = true;
                }
                if(permission === 'booking'){
                  allowBooking = true;
                }
              });
            }
          }
  
          response.data.attributes.suscriptionClient = suscriptionClient;
          response.data.attributes.BOOKING_SYNC = bookingSync;
            response.data.attributes.ALLOW_STORE = allowStore;
            response.data.attributes.ALLOW_SITE = allowSite;
            response.data.attributes.ALLOW_CRM = allowCRM;
            response.data.attributes.ALLOW_FACEBOOK = allowFacebook;
            response.data.attributes.ALLOW_BOOKING = allowBooking;
            response.data.attributes.ALLOW_GMB = allowGMB;
            response.data.attributes.ALLOW_VENTASCLICKPAY = allowVentasclickpay;
            response.data.attributes.ALLOW_DIRECTORY = allowDirectory;

            response.data.attributes.third_id = third_id;
            response.data.attributes.brand_id = response.data.attributes.brand_id;
          return BusinessModel.fromApiResponse(response.data.attributes);
        })
      );
  }

  createWebsite(): Observable<any> {
    return this.repository
      .createWebsite()
      .pipe(map((response) => response.data.attributes));
  }

  async updateMeta(payload: UpdateMetaPayloadProps): Promise<BusinessModel> {
    const response = await this.repository.updateMeta(payload);
    return BusinessModel.fromApiResponse(response.data.attributes);
  }

  registerTelmex(
    payload: any
  ): Observable<any> {

    return this.repository.registerTelmex(payload).pipe(
      map((response) => response.data)
    );
  }

  createSchedulingLink(): Observable<any> {
    return this.repository.createSchedulingLink().pipe(
      map((response) => response.data)
    );
  }

  validateSchedulingLink(): Observable<any> {
    return this.repository.validateSchedulingLink().pipe(
      map((response) => response.data)
    );
  }

  saveScoreData(
    scoreData: IRatingAppProps
  ): Observable<any> {
    return this.repository
      .saveScoreData(scoreData)
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  updateNotificationsData(payload: any): Promise<any> {
    return this.repository
      .updateNotificationsData(payload)
      .pipe(map((response) => response.data.attributes))
      .toPromise();
  }

  getNotificationsSettings(): Observable<ConfigNotificationsDataProps> {
    return this.repository.getNotificationsSettings();
  }
  

  //------ BOOKING -------
  getBookingServices(): Observable<any> {
    return this.repository.getBookingServices();
  }

  //------ UTILS -------
  getWizardUserPersonalInfo(
    businessId: number
  ): Observable<IWizardUserPersonalInfoResponse> {
    return this.repository.getWizardUserPersonalInfo(businessId);
  }
  getWizardBusinessInfo(
    businessId: number
  ): Observable<IWizardUserBusinessInfoResponse> {
    return this.repository.getWizardBusinessInfo(businessId);
  }
  getWizardBusinessAdditionalInfo(
    businessId: number
  ): Observable<IWizardUserBusinessAdditionalInfoResponse> {
    return this.repository.getWizardBusinessAdditionalInfo(businessId);
  }
  searchClient(email: string): Observable<{
    businessData: ISearchClientResponse | undefined;
    meta?: any;
  }> {
    return this.repository.searchClient(email).pipe(
      map((resp) => ({
        businessData: resp?.data?.attributes,
        meta: resp.data.meta,
      })),
      catchError((error) => {
        if (error?.message?.status === 'User does not  exist') {
          return of(null);
        }

        throw error;
      })
    );
  }
  validationCode(
    code: string
  ): Observable<JsonApiResponse<IBrandigApiProps>> {
    return this.repository.validationCode(code);
  }

  //------ ECWID -------
  setTokenEcwid(payload: ITokenEcwid): Observable<EcwidModel> {
    return this.repository.setTokenEcwid(payload).pipe(
        map(response => response.data),
        catchError(error => { throw error; })
    );
  }

  //----- Location -----

  getSearchByZipcode(zipcode: number): Observable<any> {
    return this.repository
      .getSearchByZipcode(zipcode)
      .pipe(map((response) => response.data.attributes));
  }

  getStates(): Observable<any> {
    return this.repository
      .getStates()
      .pipe(map((response) => response.data.attributes));
  }

  getLocalities(state: number): Observable<any> {
    return this.repository
      .getLocalities(state)
      .pipe(map((response) => response.data.attributes));
  }

  getSettlements(locality: number): Observable<any> {
    return this.repository
      .getSettlements(locality)
      .pipe(map((response) => response.data.attributes));
  }

  getAssociations(): Observable<any> {
    return this.repository
      .getAssociations()
      .pipe(map((response) => response.data.attributes));
  }

  //----- Account recovery -----
  sendPasswordCode(params: any): Observable<any> {
    return this.repository
      .sendResetCode(params)
      .pipe(map((response) => response.data.attributes));
  }

  validatePasswordCode(params: any): Observable<any> {
    return this.repository
      .validateCode(params)
      .pipe(map((response) => response.data.attributes));
  }

  updatePassword(params: any): Observable<any> {
    return this.repository
      .updatePassword(params)
      .pipe(map((response) => response.data.attributes));
  }

  //Redesign

  registerUser(params: any): Observable<any> {
    return this.repository
      .registerUser(params)
      .pipe(map((response) => response.data.attributes));
  }

  validateUser(params: any): Observable<any> {
    return this.repository
      .validateUser(params)
      .pipe(map((response) => response.data.attributes));
  }

  createHostedPage(params: any): Observable<any> {
    return this.repository
      .createHostedPage(params)
      .pipe(map((response) => response.data.attributes));
  }
  createHostedPageShipping(params: any): Observable<any> {
    return this.repository
      .createHostedPageShipping(params)
      .pipe(map((response) => response.data.attributes));
  }
  
  validatePayment(brand_id: number, id: string): Observable<any> {
    return this.repository
      .validatePayment(brand_id, id)
      .pipe(map((response) => response.data.attributes));
  }

  getItemPrices(brandId: number): Observable<any> {
    return this.repository
      .getItemPrices(brandId)
      .pipe(map((response) => response.data.attributes));
  }

  updateBusinessDataRegister(
    businessInfo: BusinessUpdatePayloadProps
  ): Observable<any> {

    return this.repository
      .updateBusinessData(businessInfo)
      .pipe(map((response) => response.data.attributes));
  }

  validateEmail(
    payload: any
  ): Observable<any> {

    return this.repository
      .validateEmail(payload)
      .pipe(map((response) => response.data));
  }

  getLawDocuments(brandId: number, language: string, type: string): Observable<any> {
    return this.repository
      .getLawDocuments(brandId, language, type)
      .pipe(map((response) => response.data));
  }
}
